<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      中创
      <small>header small text goes here...</small>
    </h1>
    <div class="col-lg-12" style="padding-left:0px;padding-right:0px;">
      <!-- begin panel -->
      <div class="panel panel-inverse" data-sortable-id="form-stuff-10">
        <!-- begin panel-heading -->
        <div class="panel-heading">
          <div class="panel-heading-btn">
            <a
              href="javascript:;"
              class="btn btn-xs btn-icon btn-circle btn-default"
              data-click="panel-expand"
            >
              <i class="fa fa-expand"></i>
            </a>
            <a
              href="javascript:;"
              class="btn btn-xs btn-icon btn-circle btn-success"
              data-click="panel-reload"
            >
              <i class="fa fa-redo"></i>
            </a>
            <a
              href="javascript:;"
              class="btn btn-xs btn-icon btn-circle btn-warning"
              data-click="panel-collapse"
            >
              <i class="fa fa-minus"></i>
            </a>
            <a
              href="javascript:;"
              class="btn btn-xs btn-icon btn-circle btn-danger"
              data-click="panel-remove"
            >
              <i class="fa fa-times"></i>
            </a>
          </div>
          <h4 class="panel-title">
            异常订单列表
            <span style="margin-left:1rem">Abnormal Order List</span>
          </h4>
        </div>
        <!-- end panel-heading -->
        <!-- begin panel-body -->
        <div class="panel-body">
          <form >
            <fieldset>
              <div class="form-group row m-b-15">
                <label class="col-md-1 col-form-label">开始至结束时间</label>
                <div class="col-md-3">
                  <div class="input-group date" id="default-daterange">
                    <input type="text" class="form-control">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                  </div>
                </div>
                <label class="col-md-1 col-form-label">商品名称</label>
                <div class="col-md-2">
                  <input type="text" class="form-control">
                </div>
                <div class="col-md-2">
                  <button type="submit" class="btn btn-primary m-r-5">筛选</button>
                </div>
              </div>
              <div class="form-group row m-b-15"></div>
            </fieldset>
          </form>
        </div>
        <!-- end panel-body -->
      </div>
      <!-- end panel -->
    </div>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title">异常订单列表</h4>
              </div>
              <!-- end panel-heading -->

              <!-- begin panel-body -->
              <div class="panel-body">
                <el-table :data="orderlist" border style="width: 100%">
                  <el-table-column prop="id" label="订单编号" width="180"></el-table-column>
                  <el-table-column prop="name" label="商品" width="180"></el-table-column>
                  <el-table-column prop="smallname" label="联系人"></el-table-column>
                  <el-table-column prop="location" label="联系方式"></el-table-column>
                  <el-table-column prop="platformcode" label="价格"></el-table-column>
                  <el-table-column prop="platformname" label="地址"></el-table-column>
                  <el-table-column prop="enterprisecode" label="门店"></el-table-column>
                  <el-table-column prop="enterprisename" label="快递单号"></el-table-column>
                  <el-table-column prop="time" label="下单时间"></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope></template>
                  </el-table-column>
                </el-table>
                <div style="float:right;margin-top:8px;">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="1"
                  ></el-pagination>
                </div>
                <div class="clear"></div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>

<script>
export default {
  name: "AbnormalOrderList",
  data() {
    return {
	  currentPage: 1,
	  orderlist:[]
    };
  },
  mounted: function() {
    FormPlugins.init();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderManage/AbnormalOrderList.vue